export const EVENT_TYPES = [
  "association",
  "chat",
  "coaching",
  "conference",
  "contest",
  "meeting",
  "networking",
  "podcast",
  "recruitment",
  "video",
  "visit",
  "workshop",
] as const

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// Number of minutes before the event starts from which the user can check in
export const MINUTES_BEFORE_CHECK_IN_STARTS = 30
